import lazyLoad from './lazyLoad'

export default lazyLoad
